import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { MuseumState } from '@/store/types/museum.state';
import db from "@/firebase";
import Artist from "@/models/artist";
import Artwork from "@/models/artwork";

export const actions: ActionTree<MuseumState, RootState> = {
    async fetchArtists( {commit, state}){
        const artists: Artist[] = [];
        db.collection('artists').onSnapshot((data) => {
            data.docs.map( (item, i) => {
                artists[i] = new Artist();
                artists[i].name = item.data().name;
                artists[i].description = item.data().description;
                artists[i].imageURL = item.data().imageURL;
                artists[i].scale = item.data().scale;
                if(item.data().scaleDate!=null){
                    artists[i].scaleYear = item.data().scaleDate.toDate().getFullYear();
                }
                artists[i].id = item.id;
            })
            commit('setArtists', artists);
        });
    },
    async fetchArtworks( {commit, state}){
        const artworks: Artwork[] = [];
        db.collection('artworks').onSnapshot((data) => {
            data.docs.map( (item, i) => {
                artworks[i] = new Artwork();
                artworks[i].title = item.data().title;
                artworks[i].imageURL = item.data().imageURL;
                artworks[i].type = item.data().type;
                
                artworks[i].description = item.data().description;
                artworks[i].id = item.id;
                artworks[i].authorId = item.data().author.id;
                artworks[i].date = item.data().date.toDate().getFullYear();
                const author = state.artists.find( item => item.id == artworks[i].authorId );
                if(author!=null){
                    artworks[i].authorName = author.name;
                    artworks[i].author = author;
                }
            })
            commit('setArtworks', artworks);
        });
    },
    async fetchData( {commit, dispatch}){
        commit('setLoading', true);
        dispatch('fetchArtists');
        dispatch('fetchArtworks');
        commit('setLoading', false);
    },
}